import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords = '', 
  image = 'https://canvaart.in/og-image.jpg',
  url = '',
  type = 'website',
  schema = null,
  canonical = '',
  noindex = false
}) => {
  const siteUrl = 'https://canvaart.in';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : fullUrl;
  const defaultImage = 'https://canvaart.in/og-image.jpg';
  const ogImage = image || defaultImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title ? `${title} | Canvaart` : 'Canvaart - Canvas Art Gallery & Auctions'}</title>
      <meta name="description" content={description || 'Canvaart - Professional canvas painting portfolio and auction platform. Buy original artworks, custom paintings, and participate in exclusive art auctions.'} />
      <meta name="keywords" content={keywords || 'canvas art, paintings, art gallery, custom paintings, art auction, buy paintings online, original artwork, abstract art, portrait paintings, landscape art'} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title || 'Canvaart - Canvas Art Gallery & Auctions'} />
      <meta property="og:description" content={description || 'Canvaart - Professional canvas painting portfolio and auction platform.'} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Canvaart" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title || 'Canvaart - Canvas Art Gallery & Auctions'} />
      <meta name="twitter:description" content={description || 'Canvaart - Professional canvas painting portfolio and auction platform.'} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional Meta Tags */}
      <meta name="author" content="Canvaart Artist" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      
      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;